import { render, staticRenderFns } from "./summary-info.html?vue&type=template&id=512c0524&scoped=true&external"
import script from "./summary-info.js?vue&type=script&lang=js&external"
export * from "./summary-info.js?vue&type=script&lang=js&external"
import style0 from "./summary-info.scss?vue&type=style&index=0&id=512c0524&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512c0524",
  null
  
)

export default component.exports